var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"modal"}},[(_vm.isOpen)?_c('div',{staticClass:"app-modal",on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.onBackdropClicked.apply(null, arguments)}}},[_c('div',{staticClass:"app-modal__container"},[_vm._t("default")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }